import { BannerAction } from "./engage-actions/BannerAction";
import { ModalAction } from "./engage-actions/ModalAction";
import { InlineAction } from "./engage-actions/InlineAction";
import { PaywallAction } from "./engage-actions/PaywallAction";
import { JavaScriptCallAction } from "./engage-actions/JavaScriptCallAction";
import { MessagingAction } from "./engage-actions/MessagingAction";
import { SmallInfoBoxAction } from "./engage-actions/SmallInfoBoxAction";
import { TriggerResolver } from "./triggers/TriggerResolver";
import { TriggerFactory } from "./triggers/TriggerFactory";
import { NewsletterAction } from "./engage-actions/NewsletterAction";
export class ActionProcessor {
    static process(action) {
        var _a;
        let instance;
        switch ((_a = action.actionType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
            case "banner":
                instance = new BannerAction(action);
                break;
            case "modal":
                instance = new ModalAction(action);
                break;
            case "inline":
                instance = new InlineAction(action);
                break;
            case "paywall":
                instance = new PaywallAction(action);
                break;
            case "javascriptcall":
                instance = new JavaScriptCallAction(action);
                break;
            case "messaging":
                instance = new MessagingAction(action);
                break;
            case "smallinfobox":
                instance = new SmallInfoBoxAction(action);
                break;
            case "newsletter":
                instance = new NewsletterAction(action);
                break;
            default:
                console.warn("Unknown action type:", action.actionType);
                return;
        }
        const triggerType = TriggerResolver.resolve(action);
        const trigger = TriggerFactory.create(triggerType, instance, action);
        trigger.init();
    }
}
